import { formatBRL, precosAssinatura, type Centavos, type CicloAssinatura } from "@ida/core";

export type CicloPreco = CicloAssinatura;

/** Apresentação da oferta compartilhada com a cobrança. */
export function ofertaLanding(somaContratos: Centavos, ciclo: CicloPreco) {
  const { anualPorMes, mensal, totalAnual, economiaAnual } = precosAssinatura(somaContratos);
  return {
    mensal,
    valor: ciclo === "anual" ? anualPorMes : mensal,
    totalAnual,
    economiaAnual,
    ancora: ciclo === "anual" ? `${formatBRL(mensal)}/mês` : "Sem fidelidade",
    cobranca: ciclo === "anual"
      ? `${formatBRL(totalAnual)} cobrados por ano`
      : "Cobrança mensal",
    economia: ciclo === "anual"
      ? "30% de desconto"
      : "",
  };
}

/** A home publicada é HTML estático: mantém o seletor e o slider em sincronia. */
export function iniciarPrecosLanding(root: HTMLElement, aoSimular: () => void) {
  const controle = root.querySelector<HTMLInputElement>(".lp__slider");
  const seletor = root.querySelector<HTMLInputElement>("[data-preco-ciclo]");
  if (!controle || !seletor) return;
  const atualizar = () => {
    const ciclo: CicloPreco = seletor.checked ? "anual" : "mensal";
    const soma = Number(controle.value);
    root.querySelectorAll<HTMLElement>("[data-preco-oferta]").forEach((cartao) => {
      const oferta = ofertaLanding(cartao.dataset.precoOferta === "simples" ? 0 : Math.round(soma * 100), ciclo);
      const preencher = (campo: string, texto: string) => {
        const elemento = cartao.querySelector<HTMLElement>(`[data-preco-${campo}]`);
        if (elemento) elemento.textContent = texto;
      };
      cartao.dataset.ciclo = ciclo;
      preencher("valor", formatBRL(oferta.valor));
      preencher("ancora", oferta.ancora);
      preencher("cobranca", oferta.cobranca);
      preencher("economia", oferta.economia);
    });
    const faixa = root.querySelector(".lp__preco-faixa strong");
    if (faixa) faixa.textContent = soma >= Number(controle.max)
      ? "acima de R$ 200 mil" : `R$ ${soma.toLocaleString("pt-BR")}`;
    const posicao = ((soma - Number(controle.min)) / (Number(controle.max) - Number(controle.min))) * 100;
    controle.style.background = `linear-gradient(to right, var(--acento) ${posicao}%, var(--linha) ${posicao}%)`;
  };
  seletor.addEventListener("change", atualizar);
  let mediu = false;
  controle.addEventListener("input", () => {
    atualizar();
    if (!mediu) { mediu = true; aoSimular(); }
  });
  atualizar();
}
